import React from "react";
import { Button, Grid } from "semantic-ui-react";
import InputField from "../formComponents/inputField";
import { ImportShipment } from '../../containers/importShipment';
import { ExportShipment } from '../../containers/exportShipment';
import { CheckCircle } from "../Icons";
import { useSelector } from "react-redux";

const ProrateForm = ({ translate, prorateOnclick,invoiceAmount }) => {
  // const totalInvoiceAmount = useSelector((state) => state.Shipment.totalInvoiceAmount)
  
  const [showProrate, setShowProrate] = React.useState(false);
const data = useSelector(state=>state.ValueBuildUpReducer) || {}
  return (
    <div className='prorateForm'>
      <Grid className='kn__grid'>
        <Grid.Row>
          <Grid.Column width='5' className='divFormFeild'>
            <InputField
              isLabel={false}
              id='invoiceValue'
              type='text'
              label={translate('Goods_Invoice_Value', { ns: ['default', 'valueBuildUp'] })}
              value={invoiceAmount}
              string={'€'}
              addThousandsSeperator={true}
              className={'field-bg'}
              clearInput={false}
              disabled={true}
            />
          </Grid.Column>
          {/* <ImportShipment> */}
          <ImportShipment>
            <Grid.Column width='5' className='divFormFeild'>
              <InputField
                isLabel={false}
                id='addtionCustomvalue'
                type='text'
                addThousandsSeperator={true}
                string={'€'}
                label={translate('Addition_Deduction_Customs_Value', {
                  ns: ['default', 'valueBuildUp'],
                })}
                value={data.totalAdditionDeductionCustomsValue}
                className={'field-bg'}
                clearInput={false}
                disabled={true}
              />
            </Grid.Column>
          </ImportShipment>

          <Grid.Column width='6' className='divFormFeild'>
            <InputField
              isLabel={false}
              id='addtionVatvalue'
              addThousandsSeperator={true}
              string={'€'}
              type='text'
              label={translate('Addition_Deduction_Vat_Value', {
                ns: ['default', 'valueBuildUp'],
              })}
              value={data.totalAdditionDeductionStatValue}
              className={'field-bg'}
              clearInput={false}
              disabled={true}
            />
          </Grid.Column>
          {/* </ImportShipment> */}
          {/* <ExportShipment>
            <Grid.Column width='11' className='divFormFeild'>
              <InputField
                isLabel={false}
                id='statisticalValue'
                type='text'
                label={translate('STATISTICAL_VALUE', { ns: ['default', 'valueBuildUp'] })}
                // value={}
                className={'field-bg'}
                clearInput={false}
                disabled={true}
              />
            </Grid.Column>
          </ExportShipment> */}
        </Grid.Row>
        <Grid.Row>
          <Grid.Column className='proratedApplied'>
            {data.prorateStrategy && <CheckCircle></CheckCircle>}
            <strong>{translate(data.prorateStrategy, { ns: ['default', 'valueBuildUp'] })}</strong>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  )
}

export default React.memo(ProrateForm)
